import React, { useCallback, useMemo, useRef, useState } from 'react';
export function useHorizontalScrollOverflow() {
    const [overflow, setOverflow] = useState({ left: false, right: false });
    const cleanupRef = useRef(null);
    const ref = useCallback((el) => {
        cleanupRef.current?.();
        cleanupRef.current = null;
        if (!el)
            return;
        const update = () => {
            const left = el.scrollLeft > 0;
            const right = el.scrollLeft + el.clientWidth < el.scrollWidth - 1;
            setOverflow((prev) => {
                if (prev.left === left && prev.right === right)
                    return prev;
                return { left, right };
            });
        };
        update();
        el.addEventListener('scroll', update, { passive: true });
        const observer = new ResizeObserver(update);
        observer.observe(el);
        for (const child of el.children) {
            observer.observe(child);
        }
        cleanupRef.current = () => {
            el.removeEventListener('scroll', update);
            observer.disconnect();
        };
    }, []);
    const maskStyle = useMemo(() => overflow.left || overflow.right
        ? {
            maskImage: `linear-gradient(to right, ${overflow.left ? 'transparent, black 24px,' : ''} black${overflow.right ? ' calc(100% - 24px), transparent' : ''})`,
        }
        : undefined, [overflow.left, overflow.right]);
    return { ref, overflow, maskStyle };
}
//# sourceMappingURL=useHorizontalScrollOverflow.js.map